import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_2369_118835)">
      <path
        opacity={0.8}
        d="M16.5 23L26.5 13.5L32 14V24.9999H2V12.5L9 16L16.5 23Z"
        fill="#0078EF"
      />
      <path
        d="M32 14L26.5 13.5L16.5 23L8.5 15.5L1.5 12"
        stroke="#0035A4"
      />
      <path
        opacity={0.9}
        d="M8.38462 16.2069L1 25H33V19L24.5 19.5L17.3516 10L8.38462 16.2069Z"
        fill="#C8FBE7"
      />
      <path
        d="M1 25L7.7177 16.5747L16.9939 10L24.5 19.5L33 19.1315"
        stroke="#38D695"
      />
    </g>
    <defs>
      <clipPath id="clip0_2369_118835">
        <rect
          width={20}
          height={24}
          fill="white"
          transform="translate(2 10)"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgAreaColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgAreaColored;
